import fetch from './fetch'

export function getLoginUser(): Promise<api.user.GetLoginUserResponse> {
  return fetch.get(`/user`).then(res => res.data)
}

export function confirmEmail(
  email: string
): Promise<api.user.GetResetPasswordResponse> {
  return fetch.post('/reset_password', { email }).then(res => res.data)
}

export function verifyToken(
  id: string,
  type: string
): Promise<api.user.verifyTokenResponse> {
  return fetch.get(`/tokens/${id}`, { params: { type } }).then(res => res.data)
}

export function newPassword(
  token: string,
  password: string,
  password_confirmation: string
) {
  return fetch.post(`/verify`, { token, password, password_confirmation }).then(res => res.data)
}

export function register(
  nickName: string,
  birth: string,
  email: string,
  password: string,
  confirmPassword: string,
  answerChoice: any,
  answerNote: string
  ): Promise<api.user.GetRegisterResponse> {
  return fetch.post('/user', {
    nickname: nickName,
    birth_date: birth,
    email: email,
    password: password,
    password_confirmation: confirmPassword,
    known_by_choice: answerChoice,
    known_by_note: answerNote
  }).then(res => res.data)
}

export function updateProfile(
  nickName: string,
  birth: string,
  email: string,
  image: any,
  password: string,
  confirmPassword: string,
  destroyImage: boolean | any): Promise<api.user.GetUpdateProfileResponse> {
  const formData = new FormData()
  formData.append('nickname', nickName)
  formData.append('birth_date', birth)
  formData.append('email', email)
  formData.append('_destroy_image', destroyImage)
  if (image) {
    formData.append('image', image)
  }
  if (password && confirmPassword) {
    formData.append('password', password)
    formData.append('password_confirmation', confirmPassword)
  }
  return fetch.put('/user', formData).then(res => res.data)
}

export function resendEmail(): any {
  return fetch.post(`/user/resend_reconfirmation_instructions`).then(res => res.data)
}

export function cancelEmail(): any {
  return fetch.post(`/user/cancel_reconfirmation_instructions`).then(res => res.data)
}

export function withdraw(): Promise<api.user.GetWithdrawalResponse> {
  return fetch.delete(`/user`).then(res => res.data)
}

export function confirmRegister(token: string): any {
  return fetch.post('/verify', { token }).then(res => res.data)
}

export function contact (email: string, content: string): any {
  return fetch.post(`/inquiry`,{ email, content }).then(res => res.data)
}

export function updateUserAgreement(
  arr: Array<Number>
) {
  return fetch.patch(`/user/agreements`, arr).then(res => res.data)
}
